import { ModalContainer, SectionHeader } from "../../../components";
import { currencies } from "../../../constants";
import { productStatus } from "../../../enums";
import {
  HookFormFileUpload,
  HookFormSelect,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../../hook-form";
import {
  card_numberMask,
  getCurrencyMask,
  getCurrencySymbol,
} from "../../../utils";
import { ICreateProductFormViewProps } from "./CreateProductForm";

export const View = ({
  isModalOpen,
  closeModal,
  isLoadingBankAccounts,
  activePayoutTags,
  saveProductIcon,
  actualImage,

  errors,
  handleSubmit,
  register,

  // values used for settings form
  formValues,
}: ICreateProductFormViewProps) => {
  // useEffect(() => {
  //   $(".cds--visually-hidden").change(function () {
  //     const file = $(".cds--visually-hidden").files[0];
  //     console.log(file);
  //     if (file) {
  //       let reader = new FileReader();
  //       reader.onload = function (event: any) {
  //         // console.log(event.target.result);
  //         $(".image-previewer").attr("src", event.target.result);
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   });
  // }, []);

  return (
    <form onSubmit={handleSubmit} encType="multipart/form">
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Create New Product"
            subtitle="Create a new product to sell"
            renderRight={
              <SubmitButton
                size="sm"
                className="ml-5 mr-5 pl-5 pr-5"
                showChildrenWithLoadingIcon
              >
                Create Product
              </SubmitButton>
            }
          />
        }
      >
        <TextInput
          name="product_name"
          label="Product Name"
          infoIconText="The name that customers will see"
          type="text"
          register={register}
          errors={errors}
        />

        <div className="flex-container">
          <div className="flex-box">
            <TextInput
              name="price"
              label="Price"
              type="text"
              onChange={
                // getCurrencyMask(getCurrencySymbol(formValues.currency)).onChange
                getCurrencyMask("").onChange
              }
              register={register}
              errors={errors}
            />
          </div>

          <div className="flex-box ml-md-5">
            <HookFormSelect
              name="currency"
              label="Currency"
              selectItems={currencies}
              // selectGroupedItems={}
              register={register}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex-container file-upload-container justify-content--between align-items--center">
          <HookFormFileUpload
            name="product_icon"
            buttonLabel="Upload Product thumbnail"
            label="Product Icon"
            labelTitle="Product thumbnail"
            register={register}
            errors={errors}
            className="file-upload-for-product"
            onChange={(e: any) => {
              saveProductIcon(e);
              // (e: React.ChangeEvent<HTMLInputElement>) =>
              // console.log(
              //   "File Selected: ",
              //   e.target?.files ? e.target?.files[0] : ""
              // )
            }}
          />
          <div className="image-preview">
            <img alt="product" className="image-previewer" src={actualImage} />
          </div>
        </div>
        <TextArea
          name="product_description"
          label="Description"
          register={register}
          errors={errors}
        />

        <HookFormSelect
          name="payout_tag"
          label="Preferred Payout Account"
          infoIconText="Bank account where sales of this product will be paid out to. Leave empty if you want it to be paid into your primary acct. number."
          showSkeleton={isLoadingBankAccounts}
          selectItems={[]}
          selectGroupedItems={
            activePayoutTags.map((acct) => ({
              groupLabel: `${acct.account_name} - ${acct.account_number} (${acct.bank_name})`,
              options: acct.bank_account_tags.map((tag) => ({
                text: `${tag.tag_name}`,
                value: tag.id,
              })),
            })) || []
          }
          register={register}
          errors={errors}
        />

        {/* <div className="flex-container">
          <div className="flex-box">
            <Checkbox
              name="is_subscription_product"
              label="Is Recurring"
              infoIconText="Indicates if a customer purchasing can subscribe to this product"
              register={register}
              errors={errors}
            />
          </div>

          <div className="flex-box ml-md-5">
            <HookFormSelect
              name="subscription_period"
              label="Subscription Period"
              selectItems={Object.values(subscription_period).map((m) => ({
                text: m,
                value: m,
              }))}
              disabled={!formValues.is_subscription_product}
              register={register}
              errors={errors}
            />
          </div>
        </div> */}

        {/* <HookFormSelect
          name="status"
          label="Status"
          selectItems={Object.values(productStatus).map((m) => ({
            text: m,
            value: m,
          }))}
          // selectGroupedItems={}
          register={register}
          errors={errors}
        /> */}

        {/* <div className="flex-container justify-content--end mt-5">
          <div
            id="md_alignment_helper"
            className="flex-box flex-1_5 d-none d-md-flex"
          />
          <div className="flex-box flex-container">
            <SwitchAppButton kind="danger" onClick={closeModal} size="sm">
              Cancel
            </SwitchAppButton>

            <SubmitButton size="sm" className="ml-5">
              Save
            </SubmitButton>
          </div>
        </div> */}
      </ModalContainer>
    </form>
  );
};
